import request from '@/utils/request'

export default {
  // 新增房源信息
  houseInfo (data) {
    // console.log(data, '房源');
    return request({
      url: '/houseInfo/add',
      method: 'post',
      data: data
    })
  },
  // 下架钥匙
  houseSoldOut (data) {
    return request({
      url: '/houseTrendsRecord/give/back/keys',
      method: 'post',
      data: data
    })
  },
  // 修改房源信息
  editHouseInfo (data) {
    // console.log(data, '修改房源信息');
    return request({
      url: '/houseInfo/edit',
      method: 'put',
      data: data
    })
  },
  // 录面访新增

  interviewRecord (data) {
    // console.log(data, '修改房源信息');
    return request({
      url: '/houses/interviewRecord',
      method: 'post',
      data: data
    })
  },
  // 查询房源信息列表
  houseInfoList (query) {
    // console.log('查询房源信息列表', query);
    return request({
      url: '/houseInfo/list',
      method: 'get',
      params: query
    })
  },
  // 修改标识状态
  editHouseIdentity (data) {
    // console.log(data, '房源标识状态');
    return request({
      url: '/houseInfo/edit/identity',
      method: 'post',
      data: data
    })
  },
  // 查看房源信息是否存在
  housesexists (data) {
    // console.log(data, '修改房源状态');
    return request({
      url: '/houseInfo/get/houses/exists',
      method: 'post',
      data: data
    })
  },
  // 获取房源的详细信息
  houseDetails (query) {
    // console.log(query, '获取房源详细信息')
    return request({
      url: `/houseInfo/${query}`,
      method: 'get',
      params: query
    })
  },
  // 新增实勘-编辑图片
  investigation (data) {
    // console.log(data);
    return request({
      url: '/houseInfo/update/investigation',
      method: 'put',
      data: data
    })
  },
  // 下载OSS对象存储
  downloadOssId_house (query) {
    return request({
      url: `/system/oss/download/${query}`,
      method: 'get'
    })
  },
  // 下载OSS对象存储-图片
  downloadImgOssId_house (ossId, query) {
    return request({
      url: `/system/oss/img/download/${ossId}`,
      method: 'get',
      params: query
    })
  },
  // 相关人员-编辑
  relatedPersonnelInfoEdit (data) {
    // console.log(data);
    return request({
      url: '/relatedPersonnelInfo/edit',
      method: 'put',
      data: data
    })
  },
  // 批量删除房源信息(暂无此功能)
  deleteHouse (data) {
    // console.log(data);
    return request({
      url: `/houseInfo/${data}`,
      method: 'delete'
    })
  },
  // 新增面访记录
  addInterview (data) {
    // console.log('新增访问记录', data);
    return request({
      url: '/houseTrendsRecord/add/interview',
      method: 'post',
      data: data
    })
  },
  // 查询房源动态记录列表
  getInterview (query) {
    // console.log('查询房源动态记录列表', query);
    return request({
      url: '/houseTrendsRecord/list',
      method: 'get',
      params: query
    })
  },
  // 将离职人员的私盘转为公盘  租房
  updateHouseDishTypePrivateToCompany (id) {
    return request({
      url: `/houseInfo/updateHouseDishTypePrivateToCompany/${id}`,
      method: 'put'
    })
  },
  // 将离职人员的私盘转为公盘  售房
  updateSaleHouseDishTypePrivateToCompany (id) {
    return request({
      url: `/houseInfoSale/updateHouseDishTypePrivateToCompany/${id}`,
      method: 'put'
    })
  },
  // 查询相关人员信息列表
  getRelaInfoList (query) {
    return request({
      url: '/relatedPersonnelInfo/list',
      method: 'get',
      params: query
    })
  },
  // 上传委托
  uploadEntrust (data) {
    // console.log('查询房源动态记录列表', data);
    return request({
      url: '/houseTrendsRecord/upload/entrust',
      method: 'post',
      data: data
    })
  },

  // 查看委托
  queryEntrust (query) {
    return request({
      url: '/houseTrendsRecord/query/entrust',
      method: 'get',
      params: query
    })
  },

  // 修改委托
  editEntrust (data) {
    // console.log('查询房源动态记录列表', data);
    return request({
      url: '/houseTrendsRecord/edit',
      method: 'put',
      data: data
    })
  },

  // 上传钥匙
  uploadKeysMethod (data) {
    // console.log('上传钥匙', data);
    return request({
      url: '/houseTrendsRecord/upload/keys',
      method: 'post',
      data: data
    })
  },
  // 上传图片
  addinterview (data) {
    // console.log('新增访问记录', data);
    return request({
      url: '/system/oss/upload',
      method: 'post',
      data: data
    })
  },
  // 房源ID获取业主信息
  houseOwner (query) {
    return request({
      url: '/lessorInfo/house/getLessorByHouseId',
      method: 'get',
      params: query
    })
  },
  // 获取部门团队列表
  getDeptList (query) {
    return request({
      url: '/system/dept/list',
      method: 'get',
      params: query
    })
  },
  // 获取人员列表
  getUserList (query) {
    return request({
      url: '/system/user/list',
      method: 'get',
      params: query
    })
  },
  // 新增认领记录
  addreceiveRecord (data) {
    // console.log('新增认领记录', data);
    return request({
      url: '/receiveRecord/add',
      method: 'post',
      data: data
    })
  },
  // 跟进记录
  followUpRecord (data) {
    // console.log('跟进记录', data);
    return request({
      url: '/followUpRecord/add',
      method: 'post',
      data: data
    })
  },
  // 区域列表
  district (query) {
    // console.log('区域列表', query);
    return request({
      url: '/district/list',
      method: 'get',
      params: query
    })
  },
  // 商圈列表
  businessDistrict (query) {
    // console.log('商圈列表', query);
    return request({
      url: '/businessDistrict/list',
      method: 'get',
      params: query
    })
  },
  // 新增商圈信息
  addBusinessDistrict (data) {
    // console.log('跟进记录', data);
    return request({
      url: '/businessDistrict',
      method: 'post',
      data: data
    })
  },
  // 新增街道
  addStreet (data) {
    // console.log('跟进记录', data);
    return request({
      url: '/street',
      method: 'post',
      data: data
    })
  },

  // 查询街道列表
  GetStreetList (query) {
    // console.log('查询街道列表', query);
    return request({
      url: '/street/list',
      method: 'get',
      params: query
    })
  },

  // 查询街道详细信息
  getStreet (id) {
    return request({
      url: '/street/' + id,
      method: 'get'
    })
  },

  // 根据门牌号查询小区信息
  getCommunityByQuery (query) {
    return request({
      url: '/community/query/by/houseNumber',
      method: 'get',
      params: query
    })
  },

  // 查询房源自定义标签列表
  GethouseCustomTag (query) {
    // console.log('查询街道列表', query);
    return request({
      url: '/houseCustomTag/list',
      method: 'get',
      params: query
    })
  },
  // 新增房源自定义标签信息
  houseCustomTag (data) {
    // console.log('新增自定义标签', data);
    return request({
      url: '/houseCustomTag',
      method: 'post',
      data: data
    })
  },
  // 修改房源自定义标签信息
  EdithouseCustomTag (data) {
    // console.log('修改自定义标签', data);
    return request({
      url: '/houseCustomTag',
      method: 'put',
      data: data
    })
  },
  // 获取部门列表
  deptList () {
    return request({
      url: `/system/dept/list`,
      method: 'get'
    })
  },

  // 获取部门列表
  deptListExclude (query) {
    console.log('部门列表', query)
    return request({
      url: `/system/dept/list/exclude/${query}`,
      method: 'get',
      params: query
    })
  },
  // 根据部门编号获取详细信息
  depIdPerson (query) {
    console.log('部门详细编号信息', query)
    return request({
      url: `/system/dept/${query}`,
      method: 'get'
    })
  },
  // 新增区域信息
  addDistrict (data) {
    // console.log('新增自定义标签', data);
    return request({
      url: '/district',
      method: 'post',
      data: data
    })
  },

  // 获取部门列表
  contractList (query) {
    return request({
      url: '/contractsInfo/list',
      method: 'get',
      params: query
    })
  },

  // 修改标识状态：五，独，优，钥匙
  editIdentity (data) {
    return request({
      url: '/houseInfo/edit/identity',
      method: 'post',
      data: data
    })
  },
  // 查看房源信息是否存在
  searchHouseMsg (data) {
    return request({
      url: '/houseInfo/get/houses/exists',
      method: 'post',
      data: data
    })
  },

  // 转维护人
  editMaintainer (data) {
    // console.log('修改自定义标签', data);
    return request({
      url: '/houseInfo/update/accendant',
      method: 'put',
      data: data
    })
  },
  // 修改房源状态
  editHouseInfoStatus (data) {
    return request({
      url: '/houses/statusRecord',
      method: 'post',
      data: data
    })
  },
  synchronization (data) {
    return request({
      url: '/houses/houseInfoSale/edit/synchronization',
      method: 'put',
      data
    })
  }

}
// 查询房源信息列表
export function houseInfoList (query) {
  // console.log('查询房源信息列表', query);
  return request({
    url: '/houseInfo/list',
    method: 'get',
    params: query
  })
}
// 根据当前登录人获取用户查看记录
export function userSeeRecord () {
  // console.log('查询房源信息列表', query);
  return request({
    url: '/houses/userSeeRecord/query/by/user',
    method: 'get'
  })
}
